import { FunctionalComponent } from 'preact';
import cn from 'classnames';
import Skeleton from '@material-ui/lab/Skeleton';

import styles from './styles.module.scss';

const SuggestionPlaceholder: FunctionalComponent = () => {
  return (
    <div className={cn(styles.suggestion, styles.placeholder)}>
      <Skeleton />
    </div>
  );
};

export default SuggestionPlaceholder;
